import {t} from '@lingui/macro';

import {ThunkAction} from '../../store/appThunk';
import {composeCommentAction} from '../../store/data/comments/commentsActions';
import {getFirstGlobalAdmin} from '../../store/data/teammates/teammatesSelectors';
import {getMentorAdminTeammate} from '../../store/data/userMetadata/userMetadataSelectors';
import {getLocalize} from '../../store/stateless/internationalizationSelectors';

/*
 * Action creators.
 */

export function composeTeamInboxAccessRequest(): ThunkAction {
  return (dispatch, getState) => {
    const state = getState();
    const localize = getLocalize(state);

    // Attempt to find the mentor teammate who is also an admin (i.e. the teammate that invited the user to Front).
    const mentorAdminTeammate = getMentorAdminTeammate(state);
    const firstGlobalAdmin = getFirstGlobalAdmin(state);

    // Direct the request to either the mentor teammate or the first global admin.
    const recipient = mentorAdminTeammate || firstGlobalAdmin;

    // Draft a discussion to that teammate.
    return dispatch(
      composeCommentAction({
        text: localize(
          t(
            'startguide-requestteaminbox-comment-text',
          )`Hey - could I get access to our team inboxes in Front? Thanks!`,
        ),
        topic: localize(t('startguide-requestteaminbox-comment-topic')`Team inbox access`),
        teammateIds: recipient ? [recipient.id] : [],
      }),
    );
  };
}
